import { useScrollReveal } from '@/hooks/useScrollReveal';

type AnimationVariant = 'fade-up' | 'fade-in' | 'slide-left' | 'slide-right' | 'scale-in';

interface ScrollRevealProps {
  children: React.ReactNode;
  variant?: AnimationVariant;
  delay?: number;
  duration?: number;
  threshold?: number;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

const variantClasses: Record<AnimationVariant, string> = {
  'fade-up': 'animate-fade-up',
  'fade-in': 'animate-fade-in',
  'slide-left': 'animate-slide-left',
  'slide-right': 'animate-slide-right',
  'scale-in': 'animate-scale-in',
};

export default function ScrollReveal({
  children,
  variant = 'fade-up',
  delay = 0,
  duration = 700,
  threshold,
  className = '',
  as: Tag = 'div',
}: ScrollRevealProps) {
  const { ref, isInView } = useScrollReveal({ threshold, triggerOnce: true });

  return (
    <Tag
      ref={ref}
      className={`${className} ${isInView ? variantClasses[variant] : 'opacity-0'}`}
      style={{
        animationDuration: `${duration}ms`,
        animationDelay: `${delay}ms`,
        animationFillMode: 'forwards',
      }}
    >
      {children}
    </Tag>
  );
}